module.exports = __webpack_public_path__ + "img/ricelog_pinicon_073.57c321fc.png";